module.exports = __webpack_public_path__ + "static/pizza_4-e3ca5fb82031c943ecdc90ccf9a8d529.jpg";